import React, { useRef, useEffect, cloneElement, useState } from 'react';

export const FormField = ({
	label,
	required = false,
	children,
	error,
	showErrorMessage = true,
	showErrorBorder = false,
	className = '',
	variant = ''
}) => {
	const labelRef = useRef(null);
	const containerRef = useRef(null);

	const [labelWidth, setLabelWidth] = useState(0);

	useEffect(() => {
		const updateInputPadding = () => {
			if (labelRef.current && containerRef.current) {
				const labelWidth =
					labelRef.current.offsetWidth && labelRef.current.offsetWidth > 0
						? labelRef.current.offsetWidth + 8
						: 0;
				setLabelWidth(labelWidth);
				const inputs = containerRef.current.querySelectorAll(
					'input:not(.react-select-ats__input), textarea, select, button.dropdown-ats-btn'
				);

				inputs.forEach(input => {
					input.style.paddingLeft = `${labelWidth + 12}px`;
				});
			}
		};

		updateInputPadding();
	}, [label]);

	const renderChildren = () =>
		React.Children.map(children, child =>
			React.isValidElement(child)
				? cloneElement(child, {
						customStyles: {
							control: {
								paddingLeft: `${labelWidth + 12}px`
							}
						}
					})
				: child
		);

	return (
		<div
			ref={containerRef}
			className={`form-field-v2 ${className} ${variant} ${error && showErrorBorder ? 'has-error' : ''}`}>
			{label && (
				<label ref={labelRef} className="form-field-label">
					{label} {required && <span style={{ color: '#dc3545' }}>*</span>}
				</label>
			)}
			{renderChildren()}
			{error && showErrorMessage && (
				<span className="form-field-error">{error}</span>
			)}
		</div>
	);
};
